import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
    state() {
        return {
            UserSession: [],
            UserDetailList: [],
            UserApplicationList: [],
            isAuthorized: false,
            isAuthenticated: false,
            didAutoLogout: false,
            waitingSmsToken : false,
            showSessionExpiredModal: false
        };
    },
    mutations,
    actions,
    getters
}